import { Button, Grid2 as Grid, Grid2Props, IconButton } from "@mui/material";
import React from "react";
import { singleGridItem } from "../fields/defaultStyles";
import ArraySubFormProvider from "../fields/subForms/array/ArraySubFormProvider";
import ArraySubFormList from "../fields/subForms/array/ArraySubFormList";
import { AddCircleOutline, RemoveCircleOutline } from "@mui/icons-material";
import ArraySubFormAdd from "../fields/subForms/array/ArraySubFormAdd";
import FormTextField from "../fields/basic/TextField";
import { useFormHandlerContext } from "../../../controllers/formController";

interface ReferencesListProps extends Grid2Props {
  name: string;
  label: string;
  rowLabel: string;
  disabled?: boolean;
  placeHolder?: string | ((index: number) => string);
}

const ReferencesList: React.FC<ReferencesListProps> = ({
  name,
  label,
  rowLabel,
  placeHolder,
  disabled = false,
  ...grid
}) => {
  const { isProcessing } = useFormHandlerContext();
  return (
    <Grid container spacing={1} {...singleGridItem} {...grid}>
      <ArraySubFormProvider name={name}>
        <ArraySubFormList
          renderItem={(index, remove) => (
            <FormTextField
              name="value"
              label={`${rowLabel} ${index + 1}`}
              required
              labelActions={
                <IconButton
                  color="error"
                  onClick={() => remove()}
                  size="small"
                  disabled={disabled || isProcessing}
                >
                  <RemoveCircleOutline />
                </IconButton>
              }
              placeholder={
                typeof placeHolder === "function"
                  ? placeHolder(index)
                  : placeHolder
              }
            />
          )}
        />
        <Grid {...singleGridItem}>
          <ArraySubFormAdd
            render={(append) => (
              <Button
                variant="contained"
                fullWidth
                color="primary"
                startIcon={<AddCircleOutline />}
                disabled={disabled || isProcessing}
                onClick={() =>
                  append({
                    value: "",
                  })
                }
              >
                Add {rowLabel}
              </Button>
            )}
          />
        </Grid>
      </ArraySubFormProvider>
    </Grid>
  );
};

export default ReferencesList;
